import React, { useEffect, useState } from "react";
import { Box, Card, CircularProgress } from "@mui/material";
import Highcharts from "highcharts";
import HighchartsHeatmap from "highcharts/modules/heatmap";

import Chart from "components/common/Chart";
import Text from "components/common/Text";

HighchartsHeatmap(Highcharts);

const MONTHS = [
  "January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December",
];

const normalizeHeatmapData = (data = []) => {
  if (!data.length) return [];

  const year = data[0].year;
  const monthMap = {};

  data.forEach(item => {
    monthMap[item.month] = item.portfolioReturns;
  });

  return MONTHS.map(month => ({
    year,
    month,
    portfolioReturns:
      monthMap[month] !== undefined ? monthMap[month] : "-"
  }));
};

const ROW_HEIGHT = 70;

const BacktestYearReturn = ({ title, data = [], loading }) => {
  const [options, setOptions] = useState({});
  const [chartKey, setChartKey] = useState(0);

  useEffect(() => {
    if (!Array.isArray(data) || data.length === 0) return;

    const years = [...new Set(data.map(d => d.year))].sort((a, b) => b - a);

    const heatmapData = [];

    years.forEach((year, y) => {
      MONTHS.forEach((month, x) => {
        const item = data.find(d => d.year === year && d.month === month);
     const rawValue = item?.portfolioReturns;
const isEmpty = rawValue === "-";

const value = isEmpty ? null : Number(rawValue);

   let color = "#f5f5f5"; // default for "-"
if (!isEmpty && value > 0) color = "#45ac70";
if (!isEmpty && value < 0) color = "#d55955";


        heatmapData.push({ x, y, value, color });
      });
    });

    setOptions({
      chart: {
        type: "heatmap",

        height: Math.max(years.length * ROW_HEIGHT, 180),
        spacing: [15, 15, 15, 15],
        scrollablePlotArea: {
    minWidth: 700,   // 👈 forces horizontal scroll on mobile
    scrollPositionX: 0,
  },
      },

      title: { text: null },

      xAxis: {
        categories: MONTHS.map(m => m.slice(0, 3)),
       opposite: true,
          labels: {
    style: {
      fontWeight: "600",   // 🔥 bold
      fontSize: "14px",
      color: "#000000b6",
    },
  },
      },

      yAxis: {
        categories: years.map(String),
        title: null,
        reversed: true,
        gridLineWidth: 0,
         title: {
    text: "Years",   
    y: -20,                 // 👈 your text
    align: "high",          // 👈 move title to top
    rotation: 0,            // 👈 horizontal text
    offset: 10,             // 👈 spacing from axis
    style: {
      fontWeight: "700",
      fontSize: "14px",
      color: "#000000b6",
    },
  },
      },

      legend: { enabled: false },
      tooltip: { enabled: false },

      plotOptions: {
        heatmap: {
          borderWidth: 1,
          borderColor: "#edefd8ff",
          dataLabels: {
            enabled: true,
            useHTML: true,
            formatter: function () {
  if (this.point.value === null) {
    return `
      <span style="
        color:#9e9e9e;
        font-weight:600;
        font-size:13px;
      ">
        -
      </span>
    `;
  }

  const v = this.point.value;

  return `
    <span style="
      color:${v === 0 ? "#000" : "#fff"};
      font-weight:600;
      font-size:13px;
    ">
      ${v}
    </span>
  `;
},

          },
        },
      },

      series: [
        {
          data: heatmapData,
          turboThreshold: 0,
        },
      ],

      credits: { enabled: false },
      exporting: { enabled: false },
    });

    // 🔑 force re-mount of chart
    setChartKey(prev => prev + 1);
  }, [data]);

  return (
    <Box sx={{ boxShadow: "none", borderRadius: 2 }}>
    { title && <Text sx={{ fontWeight: 600, p: 3, fontSize: 18 }}>
        {title}
      </Text>}

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", pb: 3 }}>
          <CircularProgress />
        </Box>
      ) : data?.length ? (
        <Box sx={{ height: "100%", minHeight: 200, px: 2, pb: 3 }}>
          {/* 🔑 key is CRITICAL */}
          <Chart key={chartKey} options={options} />
        </Box>
      ) : (
        <Text sx={{ textAlign: "center", pb: 3 }}>
          No Graph Data Available
        </Text>
      )}
    </Box>
  );
};

export default BacktestYearReturn;
